import anime from 'animejs'

export default {
  from: '(.*)',
  to: '(.*)',
  in: next => {
    document.querySelector('#swup').style.opacity = 0
    anime({
      targets: '#swup',
      opacity: 1,
      easing: 'spring(1, 80, 30, 0)',
      complete: next,
    })
  },
  out: next => {
    document.querySelector('#swup').style.opacity = 1
    anime({
      targets: '#swup',
      opacity: 0,
      easing: 'spring(1, 80, 30, 0)',
      complete: next,
    })
  },
}



// WEBPACK FOOTER //
// ./scripts/transitions/Generic.js